// Libraries
import classNames from 'classnames';
// Assets
import { ReactComponent as LoaderSvg } from '@assets/icons/loader.svg';
// Styles
import styles from './Loader.module.scss';
import { LoaderProps } from './LoaderProps';

const Loader = (props: LoaderProps) => {
  const { inContainer } = props;

  return inContainer ? (
    <div className={classNames('loader', styles.containerWrapper)}>
      <LoaderSvg />
    </div>
  ) : (
    <span className={classNames('loader', styles.wrapper)}>
      <LoaderSvg />
    </span>
  );
};

export default Loader;
Loader.defaultProps = {
  inContainer: true,
};
